import React, {useRef, useState} from 'react';
import {Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/utilsPrint.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPrint} from "@fortawesome/pro-duotone-svg-icons";

function Print({width, locale, name, htmlContent, children, GetContent}) {
    const printRef = useRef();
    const [iconHover, setIconHover] = useState(null);

    const ButtonPrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = GetContent
            ? GetContent()
            : htmlContent || printRef.current.innerHTML;

        printWindow.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <title>${name}</title>
          <meta charset="utf-8">
          <style>
              body {
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                  line-height: 1.6;
                  color: #333;
                  max-width: 210mm;
                  margin: 0 auto;
                  padding: 20px;
              }
              
              @media print {
                  body {
                      margin: 0;
                      padding: 15mm;
                      font-size: 12pt;
                  }
                  
                  @page {
                      margin: 15mm;
                      size: letter;
                      @top-left {content: "";}
                      @top-center {content: "";}
                      @top-right {content: "";}
                      @bottom-left {content: "";}
                      @bottom-center {content: "";}
                      @bottom-right {content: "";}
                  }
                  
                  h1, h2, h3, h4, h5, h6 { 
                    page-break-after: avoid; 
                  }
                  
                  .page-break { 
                    page-break-before: always; 
                  }
                  
                  .no-print { 
                    display: none !important; 
                  }
              }
              
              .ck-content {
                  font-family: inherit;
              }
              
              table {
                  border-collapse: collapse;
                  width: 100%;
              }
              
              table, th, td {
                  border: 1px solid #ddd;
              }
              
              th, td {
                  padding: 8px;
                  text-align: left;
              }
          </style>
          <script>
          window.addEventListener('load', function() {
              setTimeout(function() {
                  window.print();
                  
                  window.addEventListener('afterprint', function() {
                      window.close();
                  });
                  
                  setTimeout(function() {
                      try {
                          window.close();
                      } catch(e) {

                      }
                  }, 1000);
              }, 200);
          });
      </script>
      </head>
      <body>
          ${printContent}
      </body>
      </html>
    `);

        printWindow.document.close();

    };

    return (
        <>
            {children && (
                <div ref={printRef} style={{display: "none"}}>
                    {children}
                </div>
            )}
            <Button onMouseEnter={() => setIconHover('print')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-utils-print-color" onClick={() => ButtonPrint()} >
                <FontAwesomeIcon className="cs-utils-print-icon" icon={faPrint} beatFade={iconHover === 'print'} />{width > 768 && <div className="cs-utils-print-menu-text">{locale.utilsPrint.a}</div>}
            </Button>
        </>
    );
}

export default Print;
